import { render, staticRenderFns } from "./PToolbar.vue?vue&type=template&id=b22a4582"
import script from "./PToolbar.vue?vue&type=script&lang=js"
export * from "./PToolbar.vue?vue&type=script&lang=js"
import style0 from "./PToolbar.vue?vue&type=style&index=0&id=b22a4582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports